module.exports = __webpack_public_path__ + "static/media/crous_marseille.39d474ef.jpg";